<template>
  <form-section>
    <p class="item-description">
      {{ $t('Integrations_Kwiff_Text_TokenInfo') }}
    </p>
    <integration-token-box :token="model.token" />
    <p class="item-description">
      {{ $t('Integrations_Kwiff_Text_EndpointsInfo') }}
    </p>
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import IntegrationTokenBox from '@/modules/integrations/components/IntegrationTokenBox'

export default {
  name: 'KwiffOverview',

  components: {
    FormSection,
    IntegrationTokenBox
  },

  props: {
    model: {
      required: false
    }
  }
}
</script>

<style scoped>
.item-description {
  color: #808080;
  font-size: 12px;
  line-height: 18px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/types/kwiff/KwiffOverview.vue